import { Link } from "react-router-dom";
import { ShieldCheck, ListChecks, FileArchive, RefreshCcw } from "lucide-react";
import PricingCards from "@/components/PricingCards";

const FEATURES = [
  { icon: ListChecks, title: "Preview & pick", body: "See every filing on the case page with checkboxes before you download." },
  { icon: FileArchive, title: "Neatly named ZIPs", body: "Files come out as 001_Summons_Complaint.pdf, split into parts for big cases." },
  { icon: RefreshCcw, title: "Only what's new", body: "Come back later and grab just the filings added since your last export." },
];

export default function Landing() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 space-y-20" data-testid="landing-page">
      <section className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 space-y-6 fade-up">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-amber-700 bg-amber-50 border border-amber-200 px-3 py-1 rounded-full">
            <ShieldCheck size={13} /> NYSCEF & WebCivil Supreme
          </span>
          <h1 className="font-heading text-4xl sm:text-6xl font-extrabold tracking-tight leading-[1.03]">
            Every filing in a case. <span className="text-blue-600">One ZIP.</span>
          </h1>
          <p className="text-slate-600 text-lg leading-relaxed max-w-xl">
            DocketZip is a Chrome extension that batch downloads every PDF on a New York court case page, so you can stop saving filings one by one.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/sign-up" data-testid="hero-get-started-btn" className="h-12 px-6 rounded-md bg-[#1E293B] text-white font-semibold hover:bg-blue-600 hover:-translate-y-0.5 transition-[background-color,transform] flex items-center">
              Start free - 1 export
            </Link>
            <Link to="/pricing" data-testid="hero-pricing-btn" className="h-12 px-6 rounded-md border border-slate-300 font-semibold hover:bg-white transition-colors flex items-center">
              See pricing
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5 grid gap-4">
          {FEATURES.map((f, i) => (
            <div key={f.title} className="fade-up bg-white border border-slate-200 rounded-lg p-5 flex gap-4" style={{ animationDelay: `${(i + 1) * 90}ms` }}>
              <f.icon className="text-blue-600 shrink-0" size={22} />
              <div>
                <h3 className="font-heading font-semibold">{f.title}</h3>
                <p className="text-sm text-slate-600 mt-1">{f.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="space-y-8" id="pricing">
        <h2 className="font-heading text-3xl font-bold tracking-tight">Pricing</h2>
        <PricingCards />
      </section>
    </main>
  );
}
